import * as joint from '../rappid/rappid.min.js'
import '../rappid/rappid.min.css'
import dagre from 'dagre'
import graphlib from 'graphlib'
window.dagre = dagre
window.graphlib = graphlib
window.joint = joint
import './diagram.jsx'
import './stencil.jsx'